import { ICustomProperties } from '@microsoft/applicationinsights-web';

// Identifies a narrative being accumulated via addStory()/flushStory(). Add a member here for
// each flow worth reconstructing after the fact; each type gets its own buffer and its own
// enable/disable switch, independent of the others.
export enum StoryType {
	SubscriptionServicePayload = 'SubscriptionServicePayload',
	ContractWizard = 'ContractWizard'
}

export interface StoryEntry {
	timestamp: string;
	message: string;
	properties?: ICustomProperties;
	// Arbitrary data snapshot for this breadcrumb (e.g. the subscriptionService object at that
	// moment) — separate from properties, which are meant for small flat tags.
	payload?: unknown;
}

// Shape of each entry under RTDB's /logStories, used to remotely enable/disable stories without
// a deploy. `id` matches a StoryType value. `users`, when non-empty, narrows `enabled` down to
// just those uids; empty/absent means everyone. No entry for a given StoryType defaults to on.
export interface LogStoryConfig {
	id: string;
	enabled: boolean;
	users?: string[];
}
